import React from 'react';
import { CTAButton } from './CTAButton';
import { MockupImage } from './MockupImage';
import { TrustLine } from './TrustLine';
import { OFFER_ANCHOR } from '../data/constants';
export function Hero() {
  return <section className="border-b-4 border-leaf bg-white" data-id="element-72" data-mp="9lv0spiridvb">
      <div className="h-1.5 bg-forest" aria-hidden="true" data-id="element-73" data-mp="4lqictyan92g" />
      <div className="h-1 bg-gold" aria-hidden="true" data-id="element-74" data-mp="4n9zsnvorq5t" />
      <div className="mx-auto max-w-5xl px-4 pb-5 pt-3 sm:px-6 sm:pb-7 sm:pt-5" data-id="element-75" data-mp="1297esbauxdd0">
        <h1 className="mx-auto max-w-4xl text-center text-[24px] leading-[1.05] text-forest sm:text-5xl" data-id="element-76" data-mp="xae9h65q4snx">
          The complete visual plant nutrition{' '}
          <span className="text-leaf" data-id="element-77" data-mp="s9q7jpfyirex">&amp; nutrient deficiency reference system</span>
        </h1>
        <p className="mx-auto mt-2 max-w-3xl rounded bg-forest px-3 py-1.5 text-center font-display text-sm font-bold uppercase leading-tight text-white sm:text-xl" data-id="element-78" data-mp="nbop96qcuw4i">
          Stop guessing what your crops need.{' '}
          <span className="text-gold" data-id="element-79" data-mp="3814e3w60kari">Start identifying nutritional problems with confidence.</span>
        </p>

        <p className="mx-auto mt-2 max-w-3xl text-center text-sm leading-snug text-ink sm:text-base" data-id="element-80" data-mp="3j6ocnm8x2qr5">
          Recognize nutrient deficiencies, compare plant stress symptoms, interpret soil and
          tissue analysis, investigate nutritional imbalances, and evaluate crop nutrition
          problems—
          <strong className="font-bold text-forest" data-id="element-81" data-mp="30i18d5yke5em">
            all in one complete professional visual reference system.
          </strong>
        </p>

        <MockupImage className="mt-2" priority data-id="element-82" data-mp="359j8jrsrk1yj" />

        <div className="mt-2 flex flex-col items-center" data-id="element-83" data-mp="2qjv9yybyvhei">
          <CTAButton href={OFFER_ANCHOR} data-id="element-84" data-mp="2qlepgmpstof8">🚀 YES! I WANT MY PLANT NUTRITION VISUAL ATLAS NOW</CTAButton>
          <TrustLine items={['🛡️ 7-Day Money-Back Guarantee — Zero Risk']} data-id="element-85" data-mp="2vj7tb93mq6cc" />
        </div>
      </div>
    </section>;
}